<template>
  <div class="app-container post-template-detail">
    <basic-container v-loading="loading">
      <div class="operation">
        <el-button v-show="isEdit" @click="cancelEdit">取消</el-button>
        <el-button type="primary" @click="switchMode">{{isEdit ? '保存' : '编辑'}}</el-button>
      </div>
      <el-row class="one-line" v-show="!isEdit">
        <el-col :span="2">ID：</el-col>
        <el-col :span="16">{{id}}</el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="2">名称：</el-col>
        <el-col :span="16" v-show="!isEdit">{{name}}</el-col>
        <el-col :span="16" v-show="isEdit">
          <el-input :maxlength="20" v-model="name"></el-input>
        </el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="2">内容：</el-col>
        <el-col :span="16" v-show="!isEdit">
          <div v-html="content"></div>
        </el-col>
        <el-col :span="16" v-show="isEdit">
          <RichTextEditor v-model="content"
            placeholder="输入模板内容"
            :maxChars="500" />
        </el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="2">分类：</el-col>
        <el-col :span="16" v-show="!isEdit">{{tag.tagName}}</el-col>
        <el-col :span="16" v-show="isEdit">
          <el-select v-model="tag" value-key="tagId" @change="tagChange">
            <el-option
              v-for="item in tagOptions"
              :key="item.tagId"
              :label="item.tagName"
              :value="item"
              >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="2">主题：</el-col>
        <el-col :span="16" v-show="!isEdit">{{(themeTag && themeTag.themeTagName) ? themeTag.themeTagName : '--'}}</el-col>
        <el-col :span="16" v-show="isEdit">
          <el-select v-model="themeTag"
            value-key="themeTagId"
            clearable
            :disabled="themeTagOptions.length <= 0">
            <el-option
              v-for="item in themeTagOptions"
              :key="item.themeTagId"
              :label="item.themeTagName"
              :value="item"
              >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="one-line" v-show="!isEdit">
        <el-col :span="2">创建时间：</el-col>
        <el-col :span="16">{{insertedTime}}</el-col>
      </el-row>
    </basic-container>
  </div>
</template>
<script>
import { putObj, getObj } from '@/api/setting/template/postTemplate'
import { getTagsByType, getRelatedTags } from '@/api/basic/tagtype'
import RichTextEditor from '@/components/rich-text-editor/index.vue';
import { themeTagTypeId } from '@/config/const';

const initDetail = vm => {
  getObj(vm.id).then(response => {
    if (response.data.code === 0) {
      formatData(vm, response.data.data)
    }
  }).catch(error => {
    console.error(error)
    vm.$message({
      message: '获取贴息模板详情失败',
      type: 'error'
    })
  })
  getTagsByType({
    type: 2
  }).then(response => {
    vm.tagOptions = formatTagData(response.data.data)
  }).catch(error => {
    console.error(error)
    this.$message({
      message: '获取帖子分类失败',
      type: 'error'
    })
  })
}

const formatData = (vm, data) => {
  vm.name = data.name
  vm.content = data.content
  vm.tag = {
    tagId: data.tagId,
    tagName: data.tagName
  }
  if (data.themeTagId && data.themeTagName) {
    vm.themeTag = {
      themeTagId: data.themeTagId,
      themeTagName: data.themeTagName
    }
  } else {
    vm.themeTag = null;
  }
  vm.getRelatedTags(vm.tag.tagId);
  vm.insertedTime = data.insertedTime
}

const formatTagData = data => {
  if (Array.isArray(data)) {
    return data.map(x => {
      return {
        tagId: x.id,
        tagName: x.name
      }
    })
  } else {
    return []
  }
}

export default {
  data () {
    return {
      id: '',
      name: '',
      content: '',
      tag: null,
      tagOptions: [],
      insertedTime: '',
      isEdit: false,
      loading: false,
      themeTagOptions: [],
      themeTag: null,
    }
  },
  components: {
    RichTextEditor,
  },
  watch: {
    $route () {
      this.isEdit = this.$route.path.includes('edit')
      this.id = this.$route.params.id
      initDetail(this)
    }
  },
  mounted () {
    this.isEdit = this.$route.path.includes('edit')
    this.id = this.$route.params.id
    initDetail(this)
  },
  methods: {
    cancelEdit () {
      if (this.$route.path.includes('edit')) {
        this.$router.$avueRouter.closeTag()
        this.$router.go(-1)
      } else {
        this.isEdit = false
        initDetail(this)
      }
    },
    switchMode () {
      if (this.isEdit) {
        this.submit()
      } else {
        this.isEdit = true
      }
    },
    validate () {
      if (!this.name) {
        this.$message({
          message: '名称不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.content) {
        this.$message({
          message: '内容不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.tag) {
        this.$message({
          message: '分类不能为空',
          type: 'error'
        })
        return false
      }
      return true
    },
    getParams () {
      let params = {
        id: this.id,
        name: this.name,
        content: this.content,
        tagId: this.tag.tagId,
        tagName: this.tag.tagName,
      }
      if (this.themeTag != null && this.themeTag !== '') {
        params.themeTagId = this.themeTag.themeTagId;
        params.themeTagName = this.themeTag.themeTagName;
      } else {
        params.themeTagId = '';
        params.themeTagName = '';
      }
      return params
    },
    submit () {
      if (!this.validate()) {
        return false
      }
      this.loading = true
      putObj(this.getParams()).then(response => {
        if (response.data.data) {
          this.loading = false
          if (this.$route.path.includes('edit')) {
            this.$router.$avueRouter.closeTag()
            this.$router.push({
              path: `/setting/template/post/detail/${this.id}`,
            })
          } else {
            this.isEdit = false
          }
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          initDetail(this)
        }
      }).catch(error => {
        console.error(error)
        this.$message({
          message: '保存失败',
          type: 'error'
        })
        this.loading = false
      })
    },
    tagChange(tag) {
      this.themeTag = null;
      if(tag != null && tag.tagId != null){
        this.getRelatedTags(tag.tagId);
      }
    },
    // 获取与帖子类别相关的主题
    getRelatedTags(tagId) {
      const query = {
        id: tagId,
        typeId: themeTagTypeId,
      };
      getRelatedTags(query).then((response) => {
        const code = response.status;
        const data = response.data;
        if (code === 200) {
          this.themeTagOptions = [];
          if (data.data) {
            data.data.forEach((record) => {
              this.themeTagOptions.push({
                themeTagId: record.id,
                themeTagName: record.name,
              });
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    },
  }
}
</script>
<style lang="scss">
.post-template-detail {
  .one-line {
    font-size: 16px;
    margin: 10px 0;
    line-height: 40px;
  }
  .operation {
    text-align: right
  }
}
</style>
